import type {
  Concept,
  EntityMainType,
  EntitySubType,
  LinkEntityType,
} from 'domainTypes';
import {EntitySubTypes} from 'domainTypes';

export const inTargetEntityType = (
  subtype: Concept,
  type: LinkEntityType,
): boolean => {
  return (
    subtype === type ||
    (EntitySubTypes[type as EntityMainType] ?? []).includes(
      subtype as EntitySubType,
    )
  );
};
